import CareServiceRequestInfo from 'features/CareServiceRequestInfo'

export default (props) => <CareServiceRequestInfo {...{
  ...props,
  careOptionName: 'Telemedicine'
}} />
